import { ComboCompetenciaMode } from '@components/ComboCompetenciaMode';
import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { IInadimplenciaFaturaFilter } from '@services/RelatorioService';
import React from 'react';

export type InadimplenciaFaturaFilterProps = {
    filter: IFilter<IInadimplenciaFaturaFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function InadimplenciaFaturaFilter ({ filter, isLoading, empresaCombo, remetenteWhatsappCombo }: InadimplenciaFaturaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.whatsappEnvio}
                        label="Remetente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={""}>Todos</MenuItem>
                        {
                            remetenteWhatsappCombo.createOptionsWithNumero()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência"
                        updateFieldStateOnChange
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
                
                {
                    (filter.fields.competencia.value || "") !== "" && (
                        <GridItem xs={2}>
                            <ComboCompetenciaMode
                                competencia={filter.fields.competencia.value}
                                label="Restrição da Competência"
                                required
                                field={filter.fields.modoCompetencia}
                                disabled={isLoading}
                            />
                        </GridItem>
                    )
                }
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}